import { Fragment } from 'react'
import { Check } from 'lucide-react'

const Stepper = ({ steps, currentStep }) => {
  return (
    <div className="w-full bg-slate-50/50 border border-slate-100/80 rounded-xl p-2.5 md:p-3 shadow-sm mb-3">
      <div className="flex items-center justify-between w-full gap-1 md:gap-2">
        {steps.map((step, index) => {
          const StepIcon = step.icon
          const isCompleted = index < currentStep
          const isActive = index === currentStep

          return (
            <Fragment key={step.key}>
              <div className="flex items-center gap-1.5 md:gap-2 shrink-0">
                <div
                  className={`flex items-center justify-center w-7 h-7 md:w-8 md:h-8 rounded-full transition-all duration-300 relative shrink-0
                    ${isActive
                      ? 'bg-gradient-to-br from-teamcare-blue to-blue-600 text-white shadow-md shadow-blue-500/20 ring-4 ring-blue-50/70 scale-105'
                      : isCompleted
                        ? 'bg-gradient-to-br from-success-500 to-green-600 text-white shadow-sm'
                        : 'bg-white border border-slate-200 text-slate-400'
                    }
                  `}
                >
                  <StepIcon size={12} />
                  {isCompleted && (
                    <span className="absolute -top-0.5 -right-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-success-500 text-white border border-white shadow-sm animate-scale-in">
                      <Check size={8} strokeWidth={4} />
                    </span>
                  )}
                </div>

                <span
                  className={`text-[10px] md:text-xs font-semibold whitespace-nowrap transition-colors duration-200 hidden lg:block
                    ${isActive ? 'text-slate-900 font-bold' : isCompleted ? 'text-slate-600 font-medium' : 'text-slate-400'}
                  `}
                >
                  {step.label}
                </span>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-[2px] min-w-[8px] md:min-w-[16px] rounded-full transition-all duration-500
                    ${index < currentStep ? 'bg-gradient-to-r from-teamcare-blue to-teamcare-cyan' : 'bg-slate-200/50'}
                  `}
                />
              )}
            </Fragment>
          )
        })}
      </div>

      <div className="lg:hidden mt-2 text-center text-[10px] font-semibold text-slate-700">
        Step {currentStep + 1} of {steps.length}: <span className="text-slate-950 font-bold">{steps[currentStep]?.label}</span>
      </div>
    </div>
  )
}

export default Stepper
